<prf-section>
  <prf-h2 class="prf-extracurricular-activities-title">{{ extraCurricularActivities.title }}</prf-h2>
  <prf-description class="prf-extracurricular-activities-description">
    {{ extraCurricularActivities.description }}
  </prf-description>
  <prf-extracurricular-activity-cards [cards]="extraCurricularActivities.activities" />
</prf-section>
